// src/screens/AboutPage.jsx
import React from "react";
import Header from "../../components/Header";
import Footer from "../../components/Footer";

const AboutPage = () => {
  return (
    <>
      <Header />
      <div className="page-with-footer">
        <main className="page-main">
          <div className="site-shell">
            <div className="site-shell-inner">

              <section className="pt-5 pb-2 text-center">
                <h1 className="fw-bold display-5 mb-3" style={{ color: "#A30003" }}>¿Quiénes Somos?</h1>
                <p className="text-muted fs-5 mx-auto" style={{ maxWidth: "700px", color: "#A30003" }}>
                  Estilo, calidad y atención personalizada en cada prenda.
                </p>
              </section>

              <section className="py-5">
                <div className="row justify-content-center">
                  <div className="col-lg-9">
                    <p className="fs-5 text-muted lh-lg" style={{ textAlign: "justify" }}>
                      En <strong>AltaModa</strong> somos una marca local enfocada en ofrecer prendas que combinan diseño, 
                      calidad y tendencia. Acompañamos a nuestros clientes en la elección de su estilo con asesoría cercana y una experiencia de compra confiable.
                    </p>

                    <p className="fs-5 text-muted lh-lg" style={{ textAlign: "justify" }}>
                      Creemos que vestir bien no es solo una opción, es una forma de expresión. Por eso, seleccionamos 
                      cuidadosamente cada producto para garantizar comodidad, buen acabado y estilo en cada detalle.
                    </p>
                  </div>
                </div>
              </section>

            </div>
          </div>
        </main>
        <Footer />
      </div>
    </>
  );
};

export default AboutPage;
